<template>
  <g id="a266e5b0-3336-4193-b659-12ad12494fae" data-name="map">
    <polygon
      id="e7e90876-299d-4292-aa00-0e0048f488d8"
      :data-name="$t('nishi_ku')"
      points="153 817.5 11 369 306.5 337.727 378 817.5 153 817.5"
      fill="#525fff"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(34) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="bc8b22b5-7dc6-4d52-b82f-c4ad226bbd97"
      :data-name="$t('kita_ku')"
      points="306.5 337.727 280 118 457 76 623 391.5 320.997 435 306.5 337.727"
      fill="#9c3"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(35) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="a0d126fe-a347-4686-809a-7bbad0aaa096"
      :data-name="$t('omiya_ku')"
      points="320.997 435 352.516 646.5 681.976 646.5 623 391.5 320.997 435"
      fill="#ff6724"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(36) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="b1e84adf-efac-49f1-b890-25bdf91d86a1"
      :data-name="$t('minuma_ku')"
      points="523.955 203.254 792.162 101.834 1006.5 646.5 681.976 646.5 623 391.5 523.955 203.254"
      fill="#0af"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(37) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="afe2750e-e109-4766-b3d4-0797ae571a33"
      :data-name="$t('chuo_ku')"
      points="352.516 646.5 378 817.5 608 1007.255 628 646.5 352.516 646.5"
      fill="#e849b7"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(38) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="b59045a6-6bd9-475e-8b5f-9d58143b89a4"
      :data-name="$t('sakura_ku')"
      points="409.5 1194 153 817.5 378 817.5 608 1007.255 409.5 1194"
      fill="#f9c"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(39) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="a7eabb3f-8d86-480e-826f-89ca5e8c3cc0"
      :data-name="$t('urawa_ku')"
      points="628 646.5 878 646.5 874.456 1007.255 608 1007.255 628 646.5"
      fill="#f66"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(40) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="e58648b7-51df-470c-a678-f1276f7eeda7"
      :data-name="$t('minami_ku')"
      points="409.5 1194 608 1007.255 1010 1007.255 871.5 1201.5 409.5 1194"
      fill="#ffc41d"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(41) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="a9677728-cbeb-40e9-94b5-9ee686c8d300"
      :data-name="$t('midori_ku')"
      points="874.456 1007.255 878 646.5 1216.5 646.5 1216.5 1007.255 874.456 1007.255"
      fill="#6c6"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(42) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="f0a74aa8-3432-462f-a873-1ceaca175ea1"
      :data-name="$t('iwatsuki_ku')"
      points="763.5 29 1006.5 646.5 1216.5 646.5 1212 38 763.5 29"
      fill="#f7931e"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(43) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
  </g>
</template>

<script>
export default {
  props: ['shopMapIds'],
};
</script>

<style scoped>
.map-presentation {
  stroke: #fff;
  stroke-linejoin: round;
  stroke-width: 8px;
}
</style>
